module.exports = __webpack_public_path__ + "img/symbol_4.0ef58344.png";